
/**
 * @fileOverview Select2DropDown module definition
 * @author a4vdgzz
 * Last Modified: 08/12/2015
 */


(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('views/Select2DropDown',['require','jquery','lib/Util','select2'],function(require) {
        var $ = require('jquery'),
            Util = require('lib/Util'),
            select2 = require('select2');
        $debug('Select2DropDown loaded... use ?debug=Select2DropDown for messages');
        /**
         * This turns a select box into a fancy select box
         *
         * @class Select2DropDown
         * @param {jQuery} $element A reference to the containing DOM element
         * @constructor
         */
        var Select2DropDown = function ($element) {
            /**
             * A reference to the containing DOM element
             *
             * @default null
             * @property $element
             * @type {jQuery}
             * @public
             */
            this.$element = $($element);
            this.$uniqueID = $randomNumber(100000);

            /**
             * Tracks whether component is enabled.
             *
             * @default false
             * @property isEnabled
             * @type {bool}
             * @public
             */
            this.isEnabled = false;
            this.init();
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         * Exits early if it is already initialized
         *
         * @method init
         * @returns {Select2DropDown}
         * @private
         */
        Select2DropDown.prototype.init = function() {
            this.setOptions()
                .setupHandlers()
                .build();
            return this;
        };

		/**
		 * This sets the options via data-options in the html markup. If
		 * the options aren't set it goes to the defaults.
		 * Syntax for HTML should be data-options='{"enabled" : false, "focusClass" : "js-focus", "truncateTxt" : "18"}'
		 *
		 * @method setOptions
		 * @returns {Select2DropDown}
		 * @private
		 */
		Select2DropDown.prototype.setOptions = function () {
			var options = this.$element.data().options;
			
            var defaults = {
				enabled : true,
				truncateTxt : 45
			};

			this.settings = $.extend({}, defaults, options);    //merge defaults with data-options object
			$debug('\n\n******** Select2DropDown Options **********', 'Select2DropDown');
			$debug('     HTML data-options Settings: ' + $printObj(options),'Select2DropDown');
			$debug('     Default Settings: ' + $printObj(defaults),'Select2DropDown');
			$debug('     Combined Settings: ' + $printObj(this.settings),'Select2DropDown');
			return this;
		};

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * This creates event handlers and binds the scope
         * of the JS.
         *
         * @method setupHandlers
         * @returns {Select2DropDown}
         * @private
         */
        Select2DropDown.prototype.setupHandlers = function() {
            $debug('*** In setUpHandlers ***', 'Select2DropDown');
            var self = this;

            /**
             * function to truncate text
             * option created via trigger() event on domReady.
             *
             */
            $(self.$element).on('select2:close',function(){
                var _selObj = $(this),
                    len = self.settings.truncateTxt;

                $debug('truncateTxt changed', 'Select2DropDown');
                if(len !== undefined && len !== 'undefined'){
                    var _txtObj = _selObj.find(':selected'),
                        _nextObj = _selObj.next().find('.select2-selection__rendered');
                    if(_txtObj.text().length > len){
                        _nextObj.html(_txtObj.text().substring(0,len)+'...');
                    }
                }
            });
            /** 
             * function to update the selectbox and <ol> List on the fly with the dynamic
             * option created via trigger() event on domReady.
             *
             */
            $(self.$element).bind('updateOptions', function(event) {
                $debug('trigger updateOptions', 'Select2DropDown');
                var $el = $(this);
                $(arguments).each(function(idx, obj){
                    if(idx!==0){
                        var _key = obj.key||'', _val = obj.value||'';
                        $el.append('<option value="'+_key+'">'+_val+'</option>');
                    }
                });
                $el.trigger('change');
            });
            
            /** 
             * function to remove and update the selectbox and <ol> List on the fly with the dynamic
             * option created via trigger() event on domReady.
             */
            $(self.$element).bind('removeOptions', function(event) {
                $debug('trigger removeOptions', 'Select2DropDown');
                var $el = $(this);
                $(arguments).each(function(idx, obj){
                    if(idx!==0){
                        var _key = obj.key||'', _val = obj.value||'';
                        $el.find('option[value="'+_key+'"]:contains("'+_val+'")').remove();
                    }
                });
                $el.trigger('change');
            });
            
            /** 
             * function to hide the selectbox and Select2DropDowns List on the fly with the dynamic
             * option created via trigger() event on domReady.
             */
            $(self.$element).bind('hideDropdown', function() {
                $debug('trigger hideDropdown', 'Select2DropDown');
                var $el = $(this);
                $el.next().hide();

            });

            /**
             * function to hide the selectbox and Select2DropDowns List on the fly with the dynamic
             * option created via trigger() event on domReady.
             */
            $(self.$element).bind('showDropdown', function() {
                $debug('trigger showDropdown', 'Select2DropDown');
                var $el = $(this);
                $el.next().show();
            });

            return self;
        };

        /**
         * Performs measurements and applys any positioning style logic
         *
         * @method build
         * @returns {Select2DropDown}
         * @public
         */
        Select2DropDown.prototype.build = function() {
            $debug('*** In build ***', 'Select2DropDown');
            var self = this;
            var objs = $(self.$element);
            if(typeof $.fn.select2 === 'function' && objs.length > 0){
                objs.each(function(idx, obj){
                    var _obj = $(obj);
                    if(_obj.parent().find('.select2').length <= 0){
                        _obj.select2({'minimumResultsForSearch': 'Infinity'}); //create a new select2 object
                        self.$el = obj;
                    }else{
                        _obj.select2('destroy').select2({'minimumResultsForSearch': 'Infinity'}); //refresh the select2 object
                    }
                });
            }
			return self;
            
        };
        return Select2DropDown;
    });

}(MMMRequire));

